module.exports = __webpack_public_path__ + "media/src/images/testimonials/jasmin-dobrovsky-67d38d8a4f55aebe4a5722efced57818.jpg";